module.exports = __webpack_public_path__ + "60b11dc449b16f688fac1e33d2774140.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/arrow-purple-down.svg
// module id = ./app/images/arrow-purple-down.svg
// module chunks = 3